import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {WalletService} from '../wallet.service';
import {AppService} from 'src/app/app.service';
import {Constants} from 'src/app/shared/utils/constants';
import {NgForm} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ManualDepositWithdrawRequest} from '../../../models/transaction.model';
import { ExportExcelColumn, ExportService } from 'src/app/shared/services/export.service';

declare var $: any;
@Component({
  selector: 'fx-manual-deposit',
  templateUrl: './manual-deposit.component.html',
  styleUrls: ['./manual-deposit.component.sass'],
})
export class ManualDepositComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('formChangeAmount') formChangeAmount: NgForm;
  @Input() type: string;
  subscription: Subscription;
  data: any[] = [];
  condition: any = {
    asset: '',
    type: '',
    code: '',
    status: '',
    q: '',
  };
  pageInfo: any = {
    pageIndex: 1,
    pageSize: 10,
    totalRecord: 0,
  };
  loading = false;
  params: any = {};
  re = /-/gi;
  itemManual: any = {};
  isAddChange = false;
  submited = false;
  currentIndex = null;
  historyMT4Info: any = {};
  maxAmount = 100_000_000_000;
  constructor(
    private service: WalletService,
    private appService: AppService,
    private exportService: ExportService
  ) {}

  ngOnInit(): void {
    this.params.page = this.pageInfo.pageIndex;
    this.params.page_size = this.pageInfo.pageSize;
    this.getRequest();
  }
  onKeyup(event): void {
    this.searchTransaction();
  }

  searchTransaction(search?: boolean): void {
    this.params.q = (this.condition.keyword)
      ? encodeURIComponent((this.condition.keyword).trim())
      : this.condition.keyword;
    this.getRequest();
  }
  private getRequest(): void {
    this.service.getManualDepositWithdraw(this.params, this.type, ManualDepositWithdrawRequest)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.data = res.data;
          this.pageInfo.totalRecord = res.paging.total;
        }
      });
  }
  getManualInfo(item): void {
    const newItem = JSON.parse(JSON.stringify(item));
    const listData = newItem.data.map(v => {
      v.amount = 0;
      return v;
    });
    this.itemManual = {
      email: newItem.email,
      name: newItem.firstName + ' ' + newItem.lastName,
      data: listData
    };
  }
  onChangeAmount(event, item): void {
    this.isAddChange = (event === 'add');
    this.submited = true;
    this.currentIndex = item.login;
    if (item.amount <= 0 || item.amount > this.maxAmount) {
      return;
    }
    const body = {
      login: item.login,
      volume: (this.isAddChange) ? +item.amount : -item.amount
    };
    this.appService .confirm({
      title: `Are you sure that you want to ${
        (this.isAddChange) ? 'deposit' : 'withdraw'
        } amount?`,
      icon: 'fa fa-question-circle',
      ok: 'Ok',
      cancel: 'Cancel',
    })
      .subscribe((res) => {
        if (res.result) {
          this.onSubmitAmount(body);
        }
      });
  }
  onSubmitAmount(body): void {
    this.submited = false;
    this.currentIndex = null;
    this.service.updateManualAmount(body)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.appService.showSuccess(((this.isAddChange) ? 'Add' : 'Reduce')  + ' amount manual control success.');
          // $('#modalManualChangeAmount .close').trigger('click');
          this.updateCredit(body, this.isAddChange);
        } else {
          this.appService.showError(res.error_code);
        }
      });
  }
  private updateCredit(data, type): void {
    this.itemManual.data = this.itemManual.data.map(v => {
      if (v.login === data.login) {
        v.balance = (type) ? (v.balance + data.volume) : (v.balance - Math.abs(data.volume));
        v.amount = 0;
      }
      return v;
    });
  }
  getHisMT4Info(item): void {
    $('#modalManualChangeAmount').css('display', 'none');
    this.historyMT4Info = {
      login: item.login,
      currency: item.currency
    };
    const option = {
      login: item.login
    };
    this.service.getHistoryMT4Transactions(option)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.historyMT4Info.data = res.data;
        }
      });
  }

  getFormatByCurrency(currency){
    let format = '0*.00'
    if(currency == 'jpy'){
      format = '0*'
    }
    return format
  }

  pageChanged(page: number): void {
    this.pageInfo.pageIndex = page;
    this.params.page = page;
    this.getRequest();
  }

  getColumnsExport(): ExportExcelColumn<ManualDepositWithdrawRequest>[] {
    return [
      {
        field: 'id',
        title: 'ID',
        width: 30
      },
      {
        field: 'userName',
        title: 'User Name',
        transform: (data: ManualDepositWithdrawRequest) => {
          return data.getUsername();
        },
        width: 200
      },
      {
        field: 'email',
        title: 'Email',
        width: 150
      },
    ]
  }

  exportExcel() {
    const columns = this.getColumnsExport();
    this.exportService.exportExcel<ManualDepositWithdrawRequest>({
      fileName: `${this.type}_transaction.xls`,
      data: async (pageRequest) => {
        const params = {
          q: (this.condition.keyword) ? encodeURIComponent((this.condition.keyword).trim()) : this.condition.keyword,
          page: pageRequest.pageIndex + 1,
          page_size: pageRequest.pageSize
        }
        const res = await this.service.getManualDepositWithdraw<ManualDepositWithdrawRequest>(params, this.type, ManualDepositWithdrawRequest).toPromise();
        return {
          items: res?.data ?? [],
          total: res?.paging?.total ?? 0
        }
      },
      columns: columns
    })
  }


  ngAfterViewInit(): void {
    $('#modalManualChangeAmount').on('hide.bs.modal', () => {
      localStorage.setItem('un_loading', 'true');
      this.getRequest();
    });
    $('#modalHistoryAccountMT').on('hide.bs.modal', () => {
      $('#modalManualChangeAmount').hide();
    });
  }

  ngOnDestroy(): void {
  }
}
